const CODES = ["GR", "CY", "US", "CA", "GB", "IE", "DE", "FR", "IT", "ES", "PT", "NL", "BE", "LU", "CH", "AT", "DK", "SE", "NO", "FI",
  "IS", "PL", "CZ", "SK", "HU", "RO", "BG", "RS", "HR", "SI", "BA", "MK", "AL", "ME", "TR", "UA", "LT", "LV", "EE", "MT",
  "IL", "AE", "SA", "EG", "ZA", "NG", "MA", "AU", "NZ", "JP", "CN", "KR", "PH", "IN", "SG", "BR", "AR", "MX", "CL", "CO"];

const names = new Intl.DisplayNames(["en"], { type: "region" });

export const COUNTRIES = CODES.map((code) => ({ code, name: names.of(code) })).sort((a, b) => a.name.localeCompare(b.name));
